<div class="card">
  <app-header titulo="Função" descricao="Cadastro de função"></app-header>

  <div class="field">
    <label for="nome">Nome da Função:</label>
    <input id="nome" pInputText type="text" [(ngModel)]="funcao.nome" class="w-full" required autofocus>
    <small class="p-error" *ngIf="funcaoEnviada && !funcao.nome">Nome é obrigatório.</small>
  </div>

  <div class="field">
    <label for="descricao">Descrição:</label>
    <input id="descricao" pInputText type="text" [(ngModel)]="funcao.descricao" class="w-full" required autofocus>
  </div>

  <div class="field">
    <label for="modulo">Módulo:</label> <br />
    <p-cascadeSelect *ngIf="modulos" id="modulo" (onChange)="carregaAcoes(moduloSelecionado)" [(ngModel)]="moduloSelecionado" [options]="modulos" optionLabel="descricao" optionValue="id" optionGroupLabel="descricao" [optionGroupChildren]="['modulosFilhos', 'modulosFilhos']" placeholder="Selecione um módulo" /><br />
    <small class="p-error" *ngIf="funcaoEnviada && !moduloSelecionado">Módulo é obrigatório.</small>
  </div>

  <div class="field">
    <label for="modulo">Ações:</label> <br />
    <p-listbox [(ngModel)]="acoesSelecionadas" [options]="acoes" [multiple]="true" [checkbox]="true" optionLabel="descricao" emptyMessage="Sem ações cadastradas" />
  </div>

  <div class="field col-2 pt-4">
    <button
      pButton
      icon="pi pi-save"
      class="p-button-success"
      [label]="funcao.id ? 'Atualizar' : 'Salvar'"
      (click)="salvar()"
    ></button>
  </div>
</div>
